import '@/app/app.css';
import './main.css';

import '@/app/app';
import '@/layouts/main/main';

import { VideoSwitcher } from '@/shared/common/video/video-switcher';
import { vars } from '@/app/config/variables';
import { SwiperCarousel } from '@/shared/swiper/swiper-carousel/swiper-carousel';
import { Quiz } from '@/features/quiz/quiz';

window.app.SwiperCarousel = SwiperCarousel;

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-video-switcher').forEach((element) => {
		new VideoSwitcher(element);
	});

	document.querySelectorAll('.js-swiper-carousel').forEach((element) => {
		new SwiperCarousel(element);
	});

	document.querySelectorAll('.js-blog-carousel').forEach((element) => {
		new SwiperCarousel(element, {
			[vars.breakpoint.tablet]: {
				slidesPerView: 3,
				slidesOffsetBefore: 0,
				slidesOffsetAfter: 0,
				spaceBetween: 8,
			},
			[vars.breakpoint.laptop]: {
				slidesPerView: 4,
				slidesOffsetBefore: 0,
				slidesOffsetAfter: 0,
				spaceBetween: 16,
			},
		});
	});

	new Quiz();
});
